import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loaders',
  templateUrl: './loaders.component.html',
  styleUrls: ['./loaders.component.scss'],
})
export class LoadersComponent implements OnInit {
  fileTypeError = false;
  signatureError = false;
  validateSignature = false;
  validateEinvoice = false;

  constructor() {}

  ngOnInit(): void {}
}
